import React from "react";
import Marquee from "react-fast-marquee";
import "./FeaturedCompanies.css";

// Import all logos (assuming you have 10 logos in assets)
import company1 from "../../../../images/companyLogos/company1.png";
import company2 from "../../../../images/companyLogos/company2.png";
import company3 from "../../../../images/companyLogos/company3.png";
import company4 from "../../../../images/companyLogos/company4.png";
import company5 from "../../../../images/companyLogos/company5.png";
import company6 from "../../../../images/companyLogos/company6.png";
import company7 from "../../../../images/companyLogos/company7.png";
import company8 from "../../../../images/companyLogos/company8.png";
import company9 from "../../../../images/companyLogos/company9.png";
import company10 from "../../../../images/companyLogos/company10.png";

const FeaturedCompanies = () => {
  const logos = [
    company1,
    company2,
    company3,
    company4,
    company5,
    company6,
    company7,
    company8,
    company9,
    company10,
  ];

  return (
    <section className="featured-section">
      <h2 className="featured-heading">Featured Recruiter & Employees</h2>
      <Marquee 
        pauseOnHover 
        speed={50} 
        gradient={false}
      >
        {logos.map((logo, index) => (
          <img 
            key={index} 
            src={logo} 
            alt={`company-${index + 1}`} 
            className="company-logo" 
          />
        ))}
      </Marquee>
    </section>
  );
};

export default FeaturedCompanies;
